import React, { Component } from 'react';
import { DtpContentContainer, DtpAccordionGroup, DtpAccordionPanel, DtpPanel } from 'dtp-react-components';
import { Input, Button, Grid } from '../../components';

class Conversor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conversorAnoMesDiaParaDias: {
        anoParaDias: null,
        mesParaDias: null,
        diaParaDias: null,
        resultadoDias: null,
      },
      conversorDiaParaAnoMesDia: {
        dias: null,
        resultadoDiasParaAno: null,
        resultadoDiasParaMes: null,
        resultadoDiasParaDia: null,
      },
    };
  }
  handleChangeConversorAnoMesDiaParaDias = (changeObj, name) => {
    const { conversorAnoMesDiaParaDias } = { ...this.state };
    this.setState({
      conversorAnoMesDiaParaDias: {
        ...conversorAnoMesDiaParaDias,
        [name]: changeObj.value,
      },
    });
  }
  handleChangeDiaParaAnoMesDia = (changeObj, name) => {
    const { conversorDiaParaAnoMesDia } = { ...this.state };
    this.setState({
      conversorDiaParaAnoMesDia: {
        ...conversorDiaParaAnoMesDia,
        [name]: changeObj.value,
      },
    });
  }
  handleCalcularAnoMesDiaParaDias = () => {
    const { conversorAnoMesDiaParaDias } = { ...this.state };
    const ano = 365;
    const mes = 30;
    let dia = 0;
    let resultadoAnoDia = 0;
    let resultadoMesDia = 0;

    if (conversorAnoMesDiaParaDias.anoParaDias) {
      const qtdAnosDigitados = conversorAnoMesDiaParaDias.anoParaDias;
      resultadoAnoDia = (ano * qtdAnosDigitados);
    }
    if (conversorAnoMesDiaParaDias.mesParaDias) {
      const qtdMesesDigitados = conversorAnoMesDiaParaDias.mesParaDias;
      resultadoMesDia = (mes * qtdMesesDigitados);
    }
    if (conversorAnoMesDiaParaDias.diaParaDias) {
      const qtdDiasDigitados = conversorAnoMesDiaParaDias.diaParaDias;
      dia = qtdDiasDigitados;
    }

    conversorAnoMesDiaParaDias.resultadoDias = Math.round((Number(resultadoAnoDia) + Number(resultadoMesDia) + Number(dia)));

    this.setState({
      conversorAnoMesDiaParaDias: { ...this.state.conversorAnoMesDiaParaDias, conversorAnoMesDiaParaDias },
    });
  }

  handleLimparConversorDiaParaAnoMesDia = () => {
    const { conversorDiaParaAnoMesDia } = { ...this.state };
    conversorDiaParaAnoMesDia.dias = '';
    conversorDiaParaAnoMesDia.resultadoDiasParaAno = '';
    conversorDiaParaAnoMesDia.resultadoDiasParaMes = '';
    conversorDiaParaAnoMesDia.resultadoDiasParaDia = '';

    this.setState({
      conversorDiaParaAnoMesDia: { ...this.state.conversorDiaParaAnoMesDia, conversorDiaParaAnoMesDia },
    });
  }

  handleLimparConversorAnoMesDiaParaDias = () => {
    const { conversorAnoMesDiaParaDias } = { ...this.state };
    conversorAnoMesDiaParaDias.anoParaDias = '';
    conversorAnoMesDiaParaDias.mesParaDias = '';
    conversorAnoMesDiaParaDias.diaParaDias = '';
    conversorAnoMesDiaParaDias.resultadoDias = '';

    this.setState({
      conversorAnoMesDiaParaDias: { ...this.state.conversorAnoMesDiaParaDias, conversorAnoMesDiaParaDias },
    });
  }

  handleCalcularDiaParaAnoMesDia = () => {
    const { conversorDiaParaAnoMesDia } = { ...this.state };
    const ano = 365;
    const mes = 30;
    const dia = 1;
    let resultadoDiaAno = 0;
    let resultadoDiaMes = 0;
    let resultadoDiaDia = 0;

    if (conversorDiaParaAnoMesDia.dias) {
      const qtdDiasDigitados = conversorDiaParaAnoMesDia.dias;
      resultadoDiaAno = (qtdDiasDigitados / ano);
      resultadoDiaMes = ((qtdDiasDigitados % ano) / mes);
      resultadoDiaDia = ((qtdDiasDigitados % ano % mes) / dia);
    }

    conversorDiaParaAnoMesDia.resultadoDiasParaMes = Math.trunc((Number(resultadoDiaMes)));
    conversorDiaParaAnoMesDia.resultadoDiasParaAno = Math.trunc((Number(resultadoDiaAno)));
    conversorDiaParaAnoMesDia.resultadoDiasParaDia = Math.trunc((Number(resultadoDiaDia)));
    this.setState({
      conversorDiaParaAnoMesDia: { ...this.state.conversorDiaParaAnoMesDia, conversorDiaParaAnoMesDia },
    });
  }
  render() {
    return (
      <DtpContentContainer>
        <DtpAccordionGroup>
          <DtpAccordionPanel
            headingId="conversor"
            panelId="conversor-amd"
            icon="ico-calc"
            title="Conversor Ano Mes Dia para Dia"
          >
            <DtpPanel title="Converter amd/d">
              <div className="row">
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Anos"
                    maxLength="2"
                    integer
                    value={this.state.conversorAnoMesDiaParaDias.anoParaDias}
                    onChange={e => this.handleChangeConversorAnoMesDiaParaDias(e, 'anoParaDias')}
                  />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Meses"
                    maxLength="2"
                    integer
                    value={this.state.conversorAnoMesDiaParaDias.mesParaDias}
                    onChange={e => this.handleChangeConversorAnoMesDiaParaDias(e, 'mesParaDias')}
                  />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Dias"
                    integer
                    maxLength="2"
                    value={this.state.conversorAnoMesDiaParaDias.diaParaDias}
                    onChange={e => this.handleChangeConversorAnoMesDiaParaDias(e, 'diaParaDias')}
                  />
                </Grid>
                <Grid cols="1 1 1 1">
                  <Input disabled value="|" style={{ borderBottom: 'none', 'text-align': 'center' }} />
                </Grid>
                <Grid cols="1 1 1 1">
                  <Input
                    showMask={false}
                    label="Dias"
                    disabled
                    value={this.state.conversorAnoMesDiaParaDias.resultadoDias}
                  />
                </Grid>
                <Grid cols="4 4 4 4">
                  <Button
                    className="dtp-btn"
                    title="Limpar"
                    hint="Limpar"
                    onClick={this.handleLimparConversorAnoMesDiaParaDias}
                  />
                  <Button
                    className="dtp-primary"
                    title="Converter"
                    hint="Converter amd/d"
                    onClick={this.handleCalcularAnoMesDiaParaDias}
                  />
                </Grid>
              </div>
            </DtpPanel>
            <DtpPanel title="Converter d/amd">
              <div className="row">
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Dias"
                    maxLength="5"
                    integer
                    value={this.state.conversorDiaParaAnoMesDia.dias}
                    onChange={e => this.handleChangeDiaParaAnoMesDia(e, 'dias')}
                  />
                </Grid>
                <Grid cols="1 1 1 1">
                  <Input disabled value="|" style={{ borderBottom: 'none', 'text-align': 'center' }} />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Anos"
                    integer
                    disabled
                    value={this.state.conversorDiaParaAnoMesDia.resultadoDiasParaAno}
                  />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Meses"
                    integer
                    disabled
                    value={this.state.conversorDiaParaAnoMesDia.resultadoDiasParaMes}
                  />
                </Grid>
                <Grid cols="1 1 1 1">
                  <Input
                    showMask={false}
                    label="Dia"
                    disabled
                    value={this.state.conversorDiaParaAnoMesDia.resultadoDiasParaDia}
                  />
                </Grid>
                <Grid cols="4 4 4 4">
                  <Button
                    className="dtp-btn"
                    title="Limpar"
                    hint="Limpar"
                    onClick={this.handleLimparConversorDiaParaAnoMesDia}
                  />
                  <Button
                    className="dtp-primary"
                    title="Converter"
                    hint="Converter d/amd"
                    onClick={this.handleCalcularDiaParaAnoMesDia}
                  />
                </Grid>
              </div>
            </DtpPanel>
          </DtpAccordionPanel>
        </DtpAccordionGroup>
      </DtpContentContainer>
    );
  }
}

Conversor.propTypes = { };

export default Conversor;



// WEBPACK FOOTER //
// ./src/pages/conversor-amd/Conversor.jsx